export interface GetImageNaturalSizesResult {
  width: number
  height: number
}

/**
 * Function for getting original sizes for any image by src url
 */
export const getImageNaturalSizes = async (src: string): Promise<GetImageNaturalSizesResult | null> => {
  const result = new Promise<GetImageNaturalSizesResult | null>((resolve, reject) => {
    const img = new Image()
    img.src = src
    img.onload = () => {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
      })
    }
    img.onerror = () => {
      reject(new Error('Image is not available'))
    }
  })

  return result
}
